<template>
  <div class="product-informations mx-3">
    <div class="product-info-wrapper pa-3 d-flex flex-row flex-grow-1">
      <div class="side-area font-weight-light flex-shrink-0 px-3">
        <span class="font-weight-bold">SKU-specific content</span> is shown at the top of each landing page.<br><br>Information displayed here can be edited in the <iframe-link content="Products tab" link="/#/products"></iframe-link> and the Scan Response settings. 👉
        <div class="mt-7" v-if="!isAvailable('editor:authentication')" align-content="center" justify="start">
          <span class="font-weight-bold">Can't edit the elements?</span>
          <info-tooltip class="more-tooltip ml-3" content="<a href='/#/upgrade'>Upgrade today </a> to unlock more features"></info-tooltip>
        </div>
      </div>
      <div class="scan-result-area flex-grow-1">
        <div class="scan-result-area-header font-weight-bold">Top of Landing Page</div>
        <div v-if="isAvailable('editor:scan-result:logo')" class="product-tool my-2 d-flex flex-row">
          <div class="align-center  flex-row d-flex flex-grow-1 flex-shrink-1">
            <v-switch class="ma-0 hide-disabled-style" dense hide-details v-model="enableLogo" label="Logo Banner"></v-switch>
          </div>
          <div class="align-center flex-shrink-0">
            <v-btn :disabled="!isAvailable('editor:scan-result:logo') || !enableLogo" @click="logoModal = true" icon>
              <v-icon color="primary">mdi-cog-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="product-tool my-2 d-flex flex-row">
          <div class="align-center  flex-row d-flex flex-grow-1 flex-shrink-1">
            <!-- <v-switch class="ma-0" dense hide-details :disabled="true" v-model="displayProductPicture" label="Product Picture"></v-switch> -->
            <span>Product Picture</span>
          </div>
          <div class="align-center flex-shrink-0">
            <v-btn @click="pictureModal = true" icon>
              <v-icon color="primary">mdi-cog-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="product-tool my-2 d-flex flex-row">
          <div class="align-center  flex-row d-flex flex-grow-1 flex-shrink-1">
            <!-- <v-switch class="ma-0" dense hide-details :disabled="true" v-model="displayScanResult" :label="`${authMessage[previewResult]}`"></v-switch> -->
            <span>Scan Response: {{ overrideAuthMessage ? authMessage[previewResult] : defaultAuthMessage[previewResult]}}</span>
          </div>
          <div class="align-center flex-shrink-0">
            <v-btn @click="textModal = true" icon>
              <v-icon color="primary">mdi-cog-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="product-tool my-2 d-flex flex-row">
          <div class="align-center  flex-row d-flex flex-grow-1 flex-shrink-1">
            <!-- <v-switch class="ma-0" dense hide-details :disabled="true" v-model="displayProductName" label="Product Name"></v-switch> -->
            <span>Product Name</span>
          </div>
        </div>
        <div v-if="isAvailable('editor:scan-result:serial-number')" class="product-tool my-2 d-flex flex-row">
          <div class="align-center  flex-row d-flex flex-grow-1 flex-shrink-1">
            <v-switch class="ma-0" dense hide-details :disabled="!isAvailable('editor:scan-result:serial-number')" v-model="showSerialNumber" label="Serial Number"></v-switch>
          </div>
        </div>
      </div>
    </div>

    <v-dialog scrollable v-model="logoModal" width="600">
      <v-card class="dialog-form">
        <v-card-title class="headline">Logo</v-card-title>
        <v-card-text>
          <div class="pa-6">
            <div class="d-flex flex-row inset pa-6">
              <ImageCropper v-if="!logo" input-key="logo" @image-upload="onImageUpload"></ImageCropper>
              <div class="logo-ctn ml-3 d-flex flex-row align-center" v-if="logo">
                <img :src="logo">
                <v-btn @click="deleteLogo" icon>
                  <v-icon>$remove</v-icon>
                </v-btn>
              </div>
            </div>

            <div class="label font-weight-bold">Supported formats:</div>
            <div class="font-weight-light">
              PNG without background color
              JPG with pure white background
            </div>

            <div class="label font-weight-bold pt-3">Recommended image height:</div>
            <div class="font-weight-light">
              Use square or horizontal version of your logo.
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="logoModal = false" text>close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="pictureModal" width="600">
      <v-card class="dialog-form">
        <v-card-title class="headline">Product Picture Settings</v-card-title>
        <v-card-text>
          <div class="pa-6">
            <div class="py-3 ">
              <span class="description font-weight-light">Users will see different product picture depending on which product they scan. You can manage this in <iframe-link content="Products" link="/#/products"></iframe-link></span>
            </div>
            <div class="inset pt-4">
              <span class="label font-weight-medium ">Display mode</span>
              <info-tooltip v-if="!isAvailable('editor:scan-result:display-mode')" class="ml-3" content="<a href='/#/upgrade'>Upgrade today </a> to unlock this feature"></info-tooltip>
            </div>
            <v-radio-group :disabled="!isAvailable('editor:scan-result:display-mode')" v-model="productImageDisplayMode" class="inset" column>
              <v-radio value="contain" label="Contain" class="pa-0 ma-0">
              </v-radio>
              <span class="font-weight-light pl-8 pb-2">Best suited for product image that have a white background.</span>
              <v-radio value="cover" label="Cover" class="pa-0 ma-0">
              </v-radio>
              <span class="font-weight-light pl-8 pb-2">Best suited for product image with non-white background.</span>
              <v-radio value="full-width" label="Full-width" class="pa-0 ma-0">
              </v-radio>
              <span class="font-weight-light pl-8">This will scale your picture to the phone width increasing the overall size.</span>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="pictureModal = false" text>close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="textModal" width="600">
      <v-card class="dialog-form">
        <v-card-title class="headline">Scan Response Text Settings</v-card-title>
        <v-card-text>
          <div class="description font-weight-light pa-6">Edit the text to display to users who scan your product's QR code</div>
          <div class="px-6">
            <span class="label font-weight-bold">Scan Response Text </span>
            <info-tooltip v-if="!isAvailable('editor:scan-result:text')" class="ml-3" content="<a href='/#/upgrade'>Upgrade today </a> to unlock this feature"></info-tooltip>
          </div>
          <div v-if="!isAvailable('editor:authentication')">
            <v-text-field class="pa-0 px-6" :disabled="!isAvailable('editor:scan-result:text') || !overrideAuthMessage" v-model="authMessageOverride.active" hide-details placeholder="Enter a customized text"></v-text-field>
          </div>
          <div v-if="isAvailable('editor:authentication')">
            <div class="px-6">
              <v-radio-group :disabled="!isAvailable('editor:scan-result:text')" v-model="overrideAuthMessage" class="inset ma-0" column>
                <v-radio :value="false" label="Default Scan Response Text" class="py-2 ma-0">
                </v-radio>
                <v-radio :value="true" label="Customized Scan Response Text" class="ma-0">
                </v-radio>
              </v-radio-group>
            </div>
            <div class="table pl-14">
              <div class="d-flex flex-row table-header">
                <div class="item font-weight-bold text-caption">Default text</div>
                <div class="item font-weight-bold text-caption">Customized text</div>
                <!-- <div class="item font-weight-medium text-caption">icon</div> -->
              </div>
              <div v-if="isAvailable('editor:authentication')" class="d-flex flex-row flex-grow-1 table-row pt-2">
                <div class="item py-2 font-weight-bold">Genuine</div>
                <div class="item flex-grow-1">
                  <v-text-field class="ma-0 pa-0 pr-6" :disabled="!isAvailable('editor:scan-result:text') || !overrideAuthMessage" v-model="authMessageOverride.genuine" hide-details placeholder="Enter a customized text"></v-text-field>
                </div>
              </div>

              <div class="d-flex flex-row flex-grow-1 table-row pt-2">
                <div class="item py-2 font-weight-bold">Active Code</div>
                <div class="item flex-grow-1">
                  <v-text-field class="ma-0 pa-0 pr-6" :disabled="!isAvailable('editor:scan-result:text') || !overrideAuthMessage" v-model="authMessageOverride.active" hide-details placeholder="Enter a customized text"></v-text-field>
                </div>
              </div>

              <div v-if="isAvailable('editor:authentication')" class="d-flex flex-row flex-grow-1 table-row pt-2">
                <div class="item py-2 font-weight-bold">Unable To Verify</div>
                <div class="item flex-grow-1">
                  <v-text-field class="ma-0 pa-0 pr-6" :disabled="!isAvailable('editor:scan-result:text') || !overrideAuthMessage" v-model="authMessageOverride.fake" hide-details placeholder="Enter a customized text"></v-text-field>
                </div>
              </div>

              <!-- <div v-if="isAvailable('editor.authentication')" class="d-flex flex-row flex-grow-1 table-row pt-2">
                <div class="item py-2 font-weight-bold">Active Code (Unsupported phone)</div>
                <div class="item flex-grow-1">
                  <v-text-field class="ma-0 pa-0 pr-6" :disabled="!isAvailable('editor.scan-result.text') || !overrideAuthMessage" v-model="authMessageOverride['active-unsupported']" hide-details placeholder="Enter a personalized text"></v-text-field>
                </div>
              </div> -->
            </div>
          </div>

          <div class="pa-6">
            <div class="label font-weight-bold">Powered by Scantrust</div>
            <v-switch :disabled="!isAvailable('editor:scan-result:branding')" class="ma-0 pt-4" hide-details v-model="enableBranding" :label="`Display the Scantrust brand text: ${enableBranding ? 'Yes' : 'No'}`"></v-switch>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="textModal = false" text>close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import ImageCropper from '@/components/utils/ImageCropper'
import InfoTooltip from '@/components/utils/InfoTooltip'
import IframeLink from '@/components/utils/IframeLink'

export default {
  name: 'ProductInformations',
  components: {
    ImageCropper,
    InfoTooltip,
    IframeLink
  },
  watch: {
    authMessageOverride: {
      deep: true,
      handler (messages) {
        this.$store.dispatch('updateTabAuthMessage', messages)
      }
    },
    initialized (newVal) {
      if (newVal) {
        this.authMessageOverride = this.authMessage
        this.overrideAuthMessage = this.isUsingCustomAuthMessage()
        this.enableLogo = !!(this.logo && this.logo.length)
      }
    },

    enableLogo (newVal) {
      if (!newVal) {
        this.deleteLogo()
      }
    },

    overrideAuthMessage (newVal) {
      if (!newVal) {
        this.authMessageOverride = { genuine: '', active: '', fake: '', 'active-unsupported': '' }
        this.$store.dispatch('updateTabAuthMessage', this.authMessageOverride)
      }
    }
  },
  computed: {
    ...mapGetters(['authMessage', 'logo', 'initialized', 'isAvailable', 'previewResult']),

    showSerialNumber: {
      get () {
        console.log(this.$store.getters.showSerialNumber)
        return this.$store.getters.showSerialNumber
      },
      set (value) {
        this.setSerialDisplay(value)
      }
    },

    productImageDisplayMode: {
      get () {
        return this.$store.getters.productImageDisplayMode
      },
      set (value) {
        this.setDisplayMode(value)
      }
    },

    enableBranding: {
      get () {
        return this.$store.getters.enableBranding
      },
      set (value) {
        this.setBrandingMode(value)
      }
    }

    // overrideAuthMessage: {
    //   get () {
    //     return this.isUsingCustomAuthMessage()
    //   },
    //   set (newVal) {
    //     if (!newVal) {
    //       this.authMessageOverride = { genuine: '', active: '', fake: '' }
    //       this.$store.dispatch('updateTabAuthMessage', this.authMessageOverride)
    //     }
    //   }
    // }
  },
  methods: {
    ...mapMutations({
      setSerialDisplay: 'SET_SERIAL_NUMBER_DISPLAY',
      setDisplayMode: 'SET_PRODUCT_DISPLAY_MODE',
      setBrandingMode: 'SET_BRANDING_DISPLAY_MODE'
    }),

    isUsingCustomAuthMessage () {
      for (const [, val] of Object.entries(this.authMessageOverride)) {
        if (val && val.length) {
          return true
        }
      }
      return false
    },

    onImageUpload (url) {
      this.$store.dispatch('updateLogo', url)
    },

    deleteLogo () {
      this.$store.dispatch('updateLogo', '')
    }
  },
  data () {
    return {
      enableLogo: false,
      authMessageOverride: {},
      defaultAuthMessage: {
        active: 'Active Code',
        genuine: 'Genuine',
        fake: 'Unable to Verify',
        'active-unsupported': 'Active Code'
      },
      overrideAuthMessage: false,
      enableMessage: false,
      logoModal: false,
      pictureModal: false,
      textModal: false,
      displayProductPicture: true,
      displayScanResult: true,
      displayProductName: true
    }
  },
  mounted () {
    this.authMessageOverride = this.authMessage
    this.overrideAuthMessage = this.isUsingCustomAuthMessage()
  }
}

</script>

<style lang="sass" scoped>

@import '@/variables.sass'

.product-informations
  padding: 10px
  background: $bg-grey
  .product-info-wrapper
    background: white

.side-area
  max-width: 170px
  @include md
    max-width: 270px

.scan-result-area
  padding: 8px
  min-width: 265px
  border: 2px dashed rgba($pastel, 0.5)
  .scan-result-area-header
    width: 100%
    text-align: center
    color: rgba($pastel, 0.5)

.product-tool
  padding: 5px 10px
  min-height: 46px
  background: $bg-grey
  border-radius: 6px
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.3)

// ::v-deep .v-input--is-disabled
//   opacity: 1 !important

// ::v-deep .v-input--selection-controls__input
//   opacity: 0.6 !important

::v-deep label
  color: black !important

.dialog-form
  ::v-deep label
    color: rgba(0, 0, 0, 0.6) !important

.table
  .table-header
    border-bottom: 1px solid $border-grey
    .item
      width: 33.3%
      color: $label-grey
      text-transform: uppercase
      &:first-child
        max-width: 150px

  .table-row
    .item
      width: 33.3%
      &:first-child
        max-width: 150px
        color: $label-grey

.logo-ctn
  img
    height: 50px
    max-width: 300px

.description
  font-size: 16px
  color: #333333

</style>
